/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */

export type TaxReturnItemDataType = (typeof TaxReturnItemDataType)[keyof typeof TaxReturnItemDataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaxReturnItemDataType = {
    None: 'None',
    ExtractionDetails: 'ExtractionDetails',
    ExtractionMatrix: 'ExtractionMatrix',
    MatrixColumns: 'MatrixColumns',
    FormData: 'FormData',
    CalcProcessFlags: 'CalcProcessFlags',
    CalcGridXml: 'CalcGridXml',
    StatementXml: 'StatementXml',
    WhitePaper: 'WhitePaper',
    ReturnReady: 'ReturnReady',
    DataspecRowIndices: 'DataspecRowIndices',
    SystemOverrides: 'SystemOverrides',
    EnumColumnMappings: 'EnumColumnMappings',
    RowsWithDataspec: 'RowsWithDataspec',
    PostAmountsReport: 'PostAmountsReport',
    ProfileAccessXml: 'ProfileAccessXml',
    ColumnDetails: 'ColumnDetails',
    IatVariables: 'IatVariables',
    SingleContextReportList: 'SingleContextReportList',
    SingleContextReportData: 'SingleContextReportData',
    ColumnKeys: 'ColumnKeys',
    Messages: 'Messages',
    FormStatusXml: 'FormStatusXml',
    ExecutionSummary: 'ExecutionSummary',
    ExecutionSummaryReport: 'ExecutionSummaryReport',
    ReportLibraryReport: 'ReportLibraryReport',
    VisualOrgDiagram: 'VisualOrgDiagram',
    CalculationNotes: 'CalculationNotes',
    EFileExecutionSummaryReport: 'EFileExecutionSummaryReport',
    BasicCalculationDiagnostics: 'BasicCalculationDiagnostics',
    ExternalCalculationDiagnostics: 'ExternalCalculationDiagnostics',
    BasicCalculationDebugInfo: 'BasicCalculationDebugInfo',
    ExternalCalculationDebugInfo: 'ExternalCalculationDebugInfo',
    BasicCalculationContent: 'BasicCalculationContent',
    BasicCalculationResults: 'BasicCalculationResults',
    BasicCalculationData: 'BasicCalculationData',
    ExecutionSummaryReportWithDetails: 'ExecutionSummaryReportWithDetails',
    BasicOverflowReport: 'BasicOverflowReport',
    BasicDataFields: 'BasicDataFields',
    DataSourceDetail: 'DataSourceDetail',
    ModernizedCalculationDetail: 'ModernizedCalculationDetail',
    InvocationTree: 'InvocationTree',
    InstanceInfo: 'InstanceInfo',
    EnhancedDataReserved1: 'EnhancedDataReserved1',
    EnhancedDataReserved2: 'EnhancedDataReserved2',
    EnhancedDataReserved3: 'EnhancedDataReserved3',
} as const;
